import { useEffect, useRef } from 'react';
import { useRouter } from 'next/router';

import { useTrackEvent } from '@zep/logger/react';

import { useUser } from '@/lib/auth';

import { type AvatarEventSource } from '../events.quiz-profile-avatar';

/** 아바타 잠금 화면에서 로그인한 사용자가 원래 화면으로 돌아온 뒤 1회 발화한다. */
export function useAvatarLoginReturnTracking(source: AvatarEventSource) {
  const router = useRouter();
  const { isAuthenticated } = useUser();
  const { track } = useTrackEvent();
  const hasTracked = useRef(false);

  useEffect(() => {
    if (
      !router.isReady ||
      !isAuthenticated ||
      hasTracked.current ||
      router.query.avatar_login !== '1' ||
      router.query.avatar_login_source !== source
    ) {
      return;
    }

    hasTracked.current = true;
    track('quiz_profile_avatar_login_success', { source });

    const query = { ...router.query };
    delete query.avatar_login;
    delete query.avatar_login_source;
    void router.replace({ pathname: router.pathname, query }, undefined, {
      shallow: true,
    });
  }, [isAuthenticated, router, source, track]);
}
